import { render, staticRenderFns } from "./BetslipCard.vue?vue&type=template&id=27ed00a0"
import script from "./BetslipCard.vue?vue&type=script&lang=js"
export * from "./BetslipCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports